import {
  Coverage,
  CoverageEffDateRange,
  Demographics,
  Eligibility,
  MemberCoverage,
  MemberInfo,
  Name,
  PortalMemberInfo,
  TypeCode,
} from '@/common/DataModel/PortalMemberInfo';

const name: Name = {
  firstName: 'April',
  lastName: 'Sample',
};

const demographics: Demographics = {
  name,
  dateOfBirth: '1985-01-01',
  dependentSeqNbr: '00',
  address: [
    {
      addressType: 'PERMANENT',
      address1: '1111 NEW STREET',
      city: 'CYPRESS',
      state: 'CA',
      zipCode: '90630',
    },
  ],
};

const coverageEffDateRange: CoverageEffDateRange = {
  startDate: '2022-11-01',
  endDate: '2099-12-31',
};

const typeCode: TypeCode = {
  desc: 'MEDICAL',
  coverageTypeCode: 'M',
};

const coverageType: Coverage = {
  coverageEffDateRange,
  planVariationCode: '0001',
  typeCode,
  reciprocityId: '52',
};

const memberHealthCoverage: MemberCoverage = {
  coverageType: [coverageType],
};

const eligibility: Eligibility = {
  memberHealthCoverage,
};

const authMemberInfoWithPcpEnabled: MemberInfo = {
  population: '',
  demographics,
  eligibility: [eligibility],
  lineOfBusiness: 'E&I',
  policyNumber: '0915181',
  reciprocityId: '52',
  viewPcp: true,
  editPcp: true,
};

const authMemberInfoWithPcpDisabled: MemberInfo = {
  ...authMemberInfoWithPcpEnabled,
  viewPcp: false,
  editPcp: false,
};

export const MockAuthPcpEnabledPortalMemberInfo: PortalMemberInfo = {
  memberInfo: [authMemberInfoWithPcpEnabled],
};

export const MockAuthPcpDisabledPortalMemberInfo: PortalMemberInfo = {
  memberInfo: [authMemberInfoWithPcpDisabled],
};
